// extracted by mini-css-extract-plugin
export default {"mainCard":"ClaimCard_mainCard__0A9lr","claimButton":"ClaimCard_claimButton__jfn9C"};